const useGetFields = () => {

    return async ({lang, returnActive}) => {
        let response;
        try {
            response = await fetch(
                `${process.env.REACT_APP_API_URL}/active_filters?lang=${lang ? lang : 'en'}${!returnActive ? '&filter_type=all' : ''}`,
                {
                    method: 'GET',
                    headers: {
                        'Access-Control-Request-Method': 'GET'
                    }
                }
            );
        } catch (error) {
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-connection-timeout',
                source: `useGetFields - ${error.message}`
            }
            throw error;
        }

        let parsedResponse;
        try {
            parsedResponse = await response.json();
        } catch (error) {
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-bad-response',
                source: `${response.status} ${response.statusText}`
            }
            throw error;
        }

        if (response.status !== 200) {
            const error = new Error();
            if (response.status) {
                switch (response.status) {
                    case 400:
                    case 415:
                        error.clientStatusMessage = {
                            variant: 'danger',
                            i18nKey: 'error.client-bad-request',
                            source: `${response.status.toString()} ${parsedResponse.detail}`
                        }
                        break;
                    default:
                        error.clientStatusMessage = {
                            variant: 'danger',
                            i18nKey: 'error.api-bad-response',
                            source: `${response.status.toString()} ${parsedResponse.detail}`
                        }
                }
            }
            throw error;
        }

        return parsedResponse;
    }
}

export default useGetFields;
